export interface Broadcast {
  id: number
  broadcaster_name: string
  show_name: string | null
  show_description: string | null
  current_track_name: string | null
  current_track_artist: string | null
  listener_count: number
  is_live: boolean
  started_at: string
}

export interface ChatMessage {
  id: number | string
  sender_name?: string  // Legacy format
  nickname?: string      // New format
  is_broadcaster?: boolean  // Legacy format
  role?: 'broadcaster' | 'listener'  // New format
  message: string
  sent_at?: string      // Legacy format
  timestamp?: string    // New format
}

// Helper function to normalize message data
export const normalizeMessage = (msg: ChatMessage): ChatMessage => {
  return {
    ...msg,
    sender_name: msg.sender_name || msg.nickname || 'Unknown',
    is_broadcaster: msg.is_broadcaster !== undefined ? msg.is_broadcaster : msg.role === 'broadcaster',
    sent_at: msg.sent_at || msg.timestamp || new Date().toISOString(),
  }
}
